import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
//Components
import { Gallery } from "@uaveiro/ui";

const GalleryTemplate = ({ match, ...props }) => {
  const { lang } = match.params;

  return <Gallery {...props} />;
};

GalleryTemplate.propTypes = {
  match: PropTypes.object
};

export default withRouter(GalleryTemplate);
